import createClient, { type Middleware } from "openapi-fetch";
import { tokenAtual } from "../sessao/supabase";
import type { paths } from "./esquema";

/** Erro no formato do contrato da API: `{ erro, mensagem }`. */
export class ErroApi extends Error {
  constructor(readonly status: number, readonly codigo: string, mensagem: string) {
    super(mensagem);
  }
}

const credencial: Middleware = {
  async onRequest({ request }) {
    const token = await tokenAtual();
    if (token) request.headers.set("Authorization", `Bearer ${token}`);
    return request;
  },
};

export const api = createClient<paths>({ baseUrl: "" });
api.use(credencial);

/** Desembrulha a resposta: devolve os dados ou lança `ErroApi` com a mensagem pronta para a tela. */
export async function exigir<T>(p: Promise<{ data?: T; error?: unknown; response: Response }>): Promise<T> {
  const { data, error, response } = await p;
  if (error || data === undefined) {
    const e = (error ?? {}) as { erro?: string; mensagem?: string };
    throw new ErroApi(response.status, e.erro ?? "erro", e.mensagem ?? "Não foi possível falar com o sistema");
  }
  return data;
}
